import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Pause",
  "use": "Pause-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Pause\"><path fill-rule=\"evenodd\" d=\"M15 0h13v64H15V0zm21 0h13v64H36V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol